<style lang="less" scoped>
.title-div {
  font-weight: 600;
  margin: 20px 10px 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
  height: 30px;
}

.header-dropdown {
  color: #4182EB;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px 10px 20px;

  .header-container-name {
    height: 30px;
    line-height: 30px;
  }
}

.pileItem-div {
  font-weight: 600;
  margin: 0 10px !important;
  font-size: 20px;
  // flex-grow: 1;
  color: #000;
  // height: 30px;
}

.el-form-item {
  margin-bottom: 0;
  margin-left: 10px;
}

/deep/.el-form-item__label {
  text-align: left !important;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #8F9BB3;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.custInfo_container {
  width: 100%;
  margin: 20px 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;

  .cust-item {
    width: 25%;
  }
}

.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;

  >div:first-of-type {
    // width: 120px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }

  >div:last-of-type {
    font-size: 14px;
    min-width: 160px;
    text-align: right;
  }
}

.cust-detail-title {
  // text-align: ;
  // margin-right: 50px;
  // width: 150px;
}

// .cust-detail-item {
//   // t-w
// }
.page-action-btns {
  margin-bottom: 10px;
}

.cust-mes {
  margin: 0px 0px 14px 18px;
}

.top-title-div {
  font-size: 15px;
  margin-left: 10px;
}

.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 100px;
}

.detail-btn {
  height: 32px;
  margin-left: 45px;
  margin-top: 10px;
}

img {
  width: 200px;
  height: 100px;
  margin-right: 10px;
}

.pileItem-div {
  font-weight: 600;
  margin: 0 10px !important;
  font-size: 20px;
  // flex-grow: 1;
  color: #000;
  // height: 30px;
}
</style>

<template>
  <div class="detail-content-div">
    <div class="title-div">
      共享设备信息
      <el-dropdown @command="handleCommand">
        <div class="flex-r header-dropdown">
          <p class="header-container-name">{{ baseInfo.deviceCode }}</p>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="i in pileList" :key="i.pileCode" :command="i.pileCode">{{ i.pileCode
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-form :model="baseInfo" ref="formForm" label-width="120px" class="detail-form">
      <el-row :gutter="20">
        <el-col :span="24"> <span class="pileItem-div">共享信息</span> </el-col>
        <el-col :span="8">
          <el-form-item label="设备编码">
            <el-input type="text" disabled size="small" v-model="baseInfo.deviceCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="共享状态">
            <el-input type="text" disabled size="small" v-model="baseInfo.shareModelName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="站点名称">
            <el-input type="text" disabled size="small" v-model="baseInfo.shareStationName" />
          </el-form-item>
        </el-col>
        <!-- 位置信息 -->
        <el-col :span="8">
          <el-form-item label="位置信息">
            <el-input disabled clearable type="text" size="small" v-model="baseInfo.stationAddress" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="小区名称">
            <el-input disabled clearable type="text" size="small" v-model="baseInfo.communityName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车位号">
            <el-input disabled clearable type="text" size="small" v-model="baseInfo.parkSpace" />
          </el-form-item>
        </el-col>
          <el-col :span="8">
          <el-form-item label="联系人姓名">
            <el-input disabled clearable type="text" size="small" v-model="baseInfo.custName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系人电话">
            <el-input disabled clearable v-model="baseInfo.custPhone" type="text" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="停车策略">
            <el-select class="full-width" size="small" v-model="baseInfo.parkTactic" clearable placeholder="请选择"
              disabled>
              <el-option label="免费" value="01"></el-option>
              <el-option label="限时免费" value="02"></el-option>
              <el-option label="收费" value="03"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="小区对外标签">
            <el-input disabled clearable v-model="baseInfo.communityTacticName" type="text" size="small" />
          </el-form-item>
        </el-col>
        <!-- 公告 -->
        <el-col :span="8">
          <el-form-item label="公告">
            <el-input disabled clearable v-model="baseInfo.stationNotice" type="text" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="车位照片">
            <div style="text-align:left">
              <template v-if="baseInfo.attachList && baseInfo.attachList.length > 0">
                <el-image v-for="(img, index) in baseInfo.attachList" :key="index" :src="img.fileUrl"
                  :preview-src-list="imageList" fit="cover"
                  style="width: 200px; height: 100px; margin-right: 10px; margin-bottom: 10px; cursor: pointer;"></el-image>
              </template>
              <span v-else style="color: #999;">暂无照片</span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24"> <span class="pileItem-div">共享价格时段</span> </el-col>
        <el-table class="el-table" :data="shareTimePrice" border max-height="200px" style="width: 100%;margin:20px auto"
          :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
          <el-table-column type="index" label="序号" width="180" />
          <el-table-column prop="accountAply" label="时间段">
            <template slot-scope="scope">
              {{ scope.row.startTime + ' - ' + scope.row.endTime }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="applicationStatusName" label="时段类型" /> -->
          <el-table-column prop="chargeVal" label="电费（元/度）" />
          <el-table-column prop="serviceTotalVal" label="服务费（元/度）" />
          <!-- <el-table-column prop="unitPrice" label="充电单价（元/度）" /> -->
        </el-table>
        <el-col :span="24"> <span class="pileItem-div">共享开放时段</span> </el-col>
        <el-table class="el-table" :data="shareTimeOpen" border max-height="200px" style="width: 100%;margin:20px auto"
          :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
          <el-table-column type="index" label="序号" width="180" />
          <el-table-column prop="weekDayName" label="星期" />
          <el-table-column prop="sharePhone" label="共享时段">
            <template slot-scope="scope">
              <div style="width: 100%; display: flex; flex-direction: column;">
                <div v-for="(item, index) of scope.row.timeSlotList" :key="index">{{ item.startTime }} - {{ item.endTime
                }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="lastModifiedWhen" label="创建时间" />
          <el-table-column prop="weekDayStatus" label="状态" />
        </el-table>
        <!-- 共享用户列表 -->
        <el-col :span="24"><span class="pileItem-div">共享用户列表</span></el-col>
        <div style="margin: 0 10px 20px;">
          <ZD-table :tableColumns="pageConfig.shareUserListColumns" :operates="userRelationOperates"
            :tableData="userRelationList" :tableConfig="pageConfig.shareUserListTableConfig">
          </ZD-table>
          <div class="list-pagination">
            <ZD-pagination :pagination="userRelationPagination" v-on:pageUpdate="getUserRelationList"></ZD-pagination>
          </div>
        </div>
        <!-- 变更记录弹窗 -->
        <el-dialog title="变更记录" :visible.sync="showLogDialog" width="70%" :close-on-click-modal="false"
          destroy-on-close @open="onRelationLogOpen" @close="closeLogDialog">
          <ZD-table :tableColumns="pageConfig.shareUserRelationLogColumns" :tableData="relationLogList"
            :operates="{}" :tableConfig="pageConfig.shareUserRelationLogTableConfig">
          </ZD-table>
          <div class="list-pagination">
            <ZD-pagination :pagination="relationLogPagination" v-on:pageUpdate="getRelationLogList"></ZD-pagination>
          </div>
        </el-dialog>
        <el-col :span='24' class="text-right">
          <button class="common-empty-button" @click="back()">返 回</button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置

      custInfo: {}, // 列表信息
      queryInfo: {
        deviceCode: '',
        deviceType: ''
      }, // 默认内容
      pileList: [],

      baseInfo: {}, // 共享信息
      shareTimePrice: [], // 共享价格时段
      shareTimeOpen: [], // 共享开放时段
      // 用户列表
      userRelationList: [],
      userRelationPagination: { ...pageConfig.shareUserListPagination },
      userRelationOperates: {
        width: 160,
        fixed: 'right',
        list: [
          {
            id: 'viewLog',
            label: '查看变更记录',
            type: 'primary',
            show: true,
            disabled: false,
            method: (index, row) => {
              this.openRelationLog(row);
            },
          },
        ],
      },

      // 变更记录弹窗
      showLogDialog: false,
      logRow: {},
      relationLogList: [],
      relationLogPagination: { ...pageConfig.shareUserRelationLogPagination },
    }
  },
  computed: {
    imageList() {
      if (this.baseInfo.attachList && this.baseInfo.attachList.length > 0) {
        return this.baseInfo.attachList.map(item => item.fileUrl)
      }
      return []
    }
  },
  methods: {
    init() {
      let _ = this;
      console.log('11')
      const list = _.$store.state.pileObj || null
      if (list) {
        _.queryInfo.deviceCode = list.deviceCode || ''
        _.queryInfo.deviceType = list.deviceType || ''
        _.custInfo = _.$store.state.pileObj;

        // 共享信息
        _.$H.post(_, _.$A.cust.getSharePileBasicInfo, _.queryInfo).then((res) => {
          _.baseInfo = res.data.data || {};
        })

        // 共享价格时段
        _.$H.post(_, _.$A.cust.getSharePriceTime, _.queryInfo).then((res) => {
          _.shareTimePrice = res.data.data.customizeList || [];
        })

        // 共享开放时段
        _.$H.post(_, _.$A.cust.findTimeSlotByDeviceCode, _.queryInfo).then((res) => {
          _.shareTimeOpen = res.data.data.content || [];
        })

        // 用户列表
        _.getUserRelationList(_.userRelationPagination);

      }
    },

    handleCommand(val) {
      let _ = this;
      _.custInfo.pileCode = val;
    },

    back() {
      this.$router.push({
        name: "sharedSwitch"
      })
    },
    // 用户列表
    getUserRelationList(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      if (reload) {
        _.userRelationPagination.current = 1;
      } else {
        _.userRelationPagination.current = pagination.current || 1;
      }
      _.userRelationPagination.pageSize = pagination.pageSize || _.userRelationPagination.pageSize;
      const params = {
        deviceCode: _.queryInfo.deviceCode,
        deviceType: _.queryInfo.deviceType,
        pageNum: _.userRelationPagination.current - 1,
        pageSize: _.userRelationPagination.pageSize,
      };
      _.$H.post(_, _.$A.digitization.shareUserList, params).then((res) => {
        _.userRelationList = _.formatUserRelationList(res.data.data.content || []);
        _.userRelationPagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      }).catch(() => {
        _.$U.hideLoading(_);
      });
    },
    // 字典格式化（用户列表）
    formatUserRelationList(list) {
      const cfg = this.pageConfig;
      return (list || []).map((row) => ({
        ...row,
        relationTypeName: cfg.relationTypeMap[row.relationType] || row.relationType || '-',
        sourceName: cfg.sourceMap[row.source] || row.source || '-',
        hasParkSpaceName: row.hasParkSpace ? (cfg.hasParkSpaceMap[row.hasParkSpace] || '-') : '未询问',
        favoriteName: cfg.favoriteMap[row.favorite] || (row.favorite ? row.favorite : '否'),
      }));
    },
    // 打开变更记录弹窗
    openRelationLog(row) {
      this.logRow = row;
      // 重置分页
      this.relationLogPagination = { ...pageConfig.shareUserRelationLogPagination };
      // 触发 dialog 显示，实际数据加载由 @open 事件接管，
      // 避免 dialog 懒渲染时机导致 ZD-table 首次拿到空数组后不刷新
      this.showLogDialog = true;
    },
    // 变更记录弹窗 @open 回调：dialog 已渲染，安全加载数据
    onRelationLogOpen() {
      this.getRelationLogList(this.relationLogPagination);
    },
    // 变更记录列表
    getRelationLogList(pagination) {
      let _ = this;
      _.$U.showLoading(_);
      _.relationLogPagination.current = pagination.current || 1;
      _.relationLogPagination.pageSize = pagination.pageSize || _.relationLogPagination.pageSize;
      const params = {
        deviceCode: _.queryInfo.deviceCode,
        deviceType: _.queryInfo.deviceType,
        custNo: _.logRow.custNo,
        pageNum: _.relationLogPagination.current - 1,
        pageSize: _.relationLogPagination.pageSize,
      };
      _.$H.post(_, _.$A.digitization.shareUserRelationLog, params).then((res) => {
        _.relationLogList = _.formatRelationLogList(res.data.data.content || []);
        _.relationLogPagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      }).catch(() => {
        _.$U.hideLoading(_);
      });
    },
    // 字典格式化（变更记录）
    formatRelationLogList(list) {
      const cfg = this.pageConfig;
      return (list || []).map((row) => ({
        ...row,
        beforeRelationTypeName: cfg.relationTypeMap[row.beforeRelationType] || row.beforeRelationType || '-',
        afterRelationTypeName: cfg.relationTypeMap[row.afterRelationType] || row.afterRelationType || '-',
      }));
    },
    // 关闭变更记录弹窗
    closeLogDialog() {
      this.logRow = {};
      this.relationLogList = [];
      this.relationLogPagination = { ...pageConfig.shareUserRelationLogPagination };
    },
  },
  mounted() {
    this.init()
  },
}
</script>
